var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('enterpriseEnterBaseInfo',{ref:"enterpriseEnterBaseInfo",attrs:{"info":_vm.info,"companyId":_vm.companyCopyId,"enterprise":_vm.enterprise},on:{"getCompanyId":_vm.getCompanyId,"getCompanyRooms":_vm.getCompanyRooms}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }